export default "__VITE_ASSET__f097e597__"